import axios from 'axios';
import AppConfig from "../../../AppConfig";

let URL = AppConfig.HOST_API()

export default {


    getLogiEbus(page,size) {
        return axios({
            method: 'get',
            url: URL + 'appLog?page='+page+'&size='+size+'&sort=id,desc',
        });
    },

    getLogiEbusDriver(page,size) {
        return axios({
            method: 'get',
            url: URL + 'mobileLog?page='+page+'&size='+size+'&sort=idMobLog,desc',
        });
    },

    szukajLogowEbus(warunek,page,size){
        return axios({
            method: 'get',
            url: URL + 'appLog/search?warunek='+warunek+'&page='+page+'&size='+size+'&sort=id,desc',
        });
    },

    pobierzSlownikEventowWLogach(){
        return axios({
            method: 'get',
            url: URL + 'appLog/slownik/event',
        });
    },

    pobierzSlownikTypowWLogach(){
        return axios({
            method: 'get',
            url: URL + 'appLog/slownik/typ',
        });
    },



}


// WEBPACK FOOTER //
// ./src/modules/administracja/logi/LogiService.js